// extracted by mini-css-extract-plugin
export default {"item-form":"experience-transfer-details__item-form--trlXB","itemForm":"experience-transfer-details__item-form--trlXB","spacing":"experience-transfer-details__spacing--aqVey"};